import { ChevronDownIcon, ChevronUpIcon } from '@shared/assets/icons';
import * as stylex from '@stylexjs/stylex';
import { FC, useState } from 'react';
import { styles } from './styles';

interface AccordionProps {
  element?: React.ReactNode;
  children: React.ReactNode;
  onToggle?: (isOpen: boolean) => void;
}

export const Accordion: FC<AccordionProps> = ({ element, children, onToggle }) => {
  const [isOpen, setIsOpen] = useState(false);

  const openHandler = () => {
    onToggle && onToggle(!isOpen);
    setIsOpen(!isOpen);
  };

  return (
    <div {...stylex.props(styles.mainContainer)}>
      <div {...stylex.props(styles.parentContainer)}>
        <div {...stylex.props(styles.leftContainer)}>
          <button onClick={openHandler} {...stylex.props(styles.icon)}>
            {isOpen ? <ChevronUpIcon /> : <ChevronDownIcon />}
          </button>

          {element}
        </div>
      </div>

      {isOpen && children ? <div {...stylex.props(styles.childContainer)}>{children}</div> : null}
    </div>
  );
};
